export default {
  kenya: {
    id: 'RUBISKE',
    currency: 'KES',
    currencyIsoCode: '404',
    calling_code: '254',
    code: 'en-KE',
    country_code: 'KE',
    default_locale_lang: 'en',
    accepted_payment_methods: ['@MPESA'],
    default_coordinates: {
      lat: -1.27429988789045,
      lng: 36.80847367874171,
    },
  },
  uganda: {
    id: 'RUBISUG',
    currency: 'UGX',
    currencyIsoCode: '800',
    calling_code: '256',
    code: 'en-UG',
    default_locale_lang: 'en',
    accepted_payment_methods: [],
    country_code: 'UG',
    default_coordinates: {
      lat: 0.341867,
      lng: 32.579195,
    },
  },
  zambia: {
    id: 'RUBISZM',
    currency: 'ZMW',
    currencyIsoCode: '967',
    calling_code: '260',
    code: 'en-ZK',
    default_locale_lang: 'en',
    country_code: 'ZM',
    default_coordinates: {
      lat: -15.404035141169361,
      lng: 28.263990460073224,
    },
    accepted_payment_methods: [],
  },
  rwanda: {
    id: 'RUBISRW',
    currency: 'RWF',
    currencyIsoCode: '646',
    calling_code: '250',
    code: 'en-RW',
    default_locale_lang: 'fr',
    country_code: 'RW',
    accepted_payment_methods: [],
    default_coordinates: {
      lat: -1.9407426838569413,
      lng: 30.086715218964237,
    },
  },
  madagascar: {
    id: import.meta.env.VITE_NODE_ENV === 'dev' ? 'RUBISMG' : 'GALANAMG',
    currency: 'MGA',
    currencyIsoCode: '969',
    calling_code: '261',
    code: 'fr-FR',
    country_code: 'MG',
    default_locale_lang: 'fr',
    accepted_payment_methods: [],
    default_coordinates: {
      lat: -18.8876785,
      lng: 47.5125139,
    },
  },
}
